import { render, staticRenderFns } from "./InterventionForm.vue?vue&type=template&id=6fb08e9e"
import script from "./InterventionForm.vue?vue&type=script&lang=js"
export * from "./InterventionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports